import { reportRaptorMetrics } from '@/common/SLRaptor';
import { ModuleInfo } from '../component';
/**
 * 将多api数据根据index排序，保证数据展示顺序和和api顺序一致
 * @param moduleData module_header、module_body、module_footer数据
 */
export const moduleKeysSort = (moduleData: {[index: number]: ModuleInfo;}) => {
  const moduleKeys = Object.keys(moduleData);
  const moduleNumberKeys: number[] = [];
  moduleKeys.forEach((key) => {
    moduleNumberKeys.push(Number(key));
  });
  moduleNumberKeys.sort((a, b) => a - b);
  return moduleNumberKeys;
};

/**
 * 首页接口有广告数据时，上报raptor
 * @param headerComponentList
 */
export const reportAdsApiEvent = (headerComponentList: []) => {
  let adCount = 0;
  let shopIndexList = '';
  let shopIdList = '';
  for (let index = 0; index < headerComponentList.length; index++) {
    const element = headerComponentList[index];
    // @ts-ignore
    if (element?.json_data?.adInfo?.hitAd === 1) {
      adCount++;
      shopIndexList = `${shopIndexList + index}-`;
      // @ts-ignore
      shopIdList = `${shopIdList + element?.json_data?.shopId}-`;
    }
  }
  if (adCount > 0) {
    console.log('home list has ad shop, adCount: ', adCount);
    reportRaptorMetrics({ SailorAdsApiEvent: 1 }, {
      ads_count: String(adCount),
      shop_index_list: shopIndexList,
      shop_id_list: shopIdList
    });
  }
};

/**
 * 首页头部运营区数据异常打点
 */
export const reportHeaderDataError = (hasTopView: boolean, dataType: string) => {
  reportRaptorMetrics({ TopViewDataError: 1 }, {
    hasTopView: hasTopView ? 'true' : 'false',
    dataType,
  });
};

export const isHitErrorCatch = () => {
  const WMABTest = Mach?.requireModule?.('SLABStrategy');
  const strategy = WMABTest?.getRealTimeStrategy?.({
    sceneKey: 'puzzle_error_catch',
    groupKey: 'homepage_error_catch_exp'
  });
  return ['A'].includes(strategy?.expKey);
};
